import React, { Component } from 'react';
import { Container, Col } from 'reactstrap';
import DarkSkyLogo from './darkskylogo.png' 
import './Footer.css';
 

class Footer extends Component {
  render() {
    return (
         <div className="footer">
          <Container>
            <Col className="footer-col">&#169;{new Date().getFullYear()} Copyright &nbsp;|&nbsp; All rights reserved &nbsp;|&nbsp; 
                Privacy Policy &nbsp;|&nbsp; Legal &nbsp;|&nbsp; <a href="https://darksky.net">Weather Data Powered by Dark Sky</a> <img href="https://darksky.net" src={DarkSkyLogo} alt="Dark Sky Icon" height="32" width="32"></img></Col>
          </Container>

            
        </div>
    );
  }
}

export default Footer;